import { Component, EventEmitter, inject, Output, ChangeDetectionStrategy } from '@angular/core';
import { CuiButtonComponent } from '@idealink-material/ui-core';
import { AUTH_SERVICE_TOKEN } from '@/core/util/auth.token';
import { IAuthSession } from '@/core/interface/auth-service.interface';
import { SessionMonitorService } from '@/core/service/session-monitor.service';
import { SessionStatus } from '@/core/model/session-status';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-session-duration-expired',
  template: `
    <div
      class="fixed inset-0 z-50 flex items-center justify-center p-4"
      style="background: rgba(17, 24, 39, 0.5)"
    >
      <div
        class="rounded-xl w-full max-w-sm p-6 text-center"
        style="background: var(--bg-card); box-shadow: var(--shadow-card)"
      >
        <h3 class="text-lg font-bold mb-3" style="color: var(--text-primary)">
          {{ 'session.expired.title' | translate }}
        </h3>
        <p class="text-sm mb-6" style="color: var(--text-muted)">
          {{ 'session.expired.message' | translate }}
        </p>
        <p-button [fullWidth]="true" icon="logout" (onClick)="closed()">Logout</p-button>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CuiButtonComponent, TranslatePipe],
})
export class SessionDurationExpired {
  @Output() onHide = new EventEmitter<void>();
  authService: IAuthSession = inject(AUTH_SERVICE_TOKEN);
  private sessionMonitor = inject(SessionMonitorService);

  closed() {
    this.closeDialog();
    this.sessionMonitor.setStatus(SessionStatus.Active);
    this.authService.logout();
  }

  closeDialog() {
    this.onHide.emit();
  }
}
